// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3g0us","footer":"ModalFilter_footer__1_VuV"};